import { Spinner } from '@ibsys/kit';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import type { ConversationPipeline, ExpertReportPipelineScope } from '@/entities/search';
import { PipelineActions } from './PipelineActions';

type Props = {
  /** Число отмеченных диалогов — выводится в блоке «Выбрано: N» справа от действий */
  selectedCount: number;
  /** Есть что запускать: отмечена хотя бы одна строка */
  hasSelection: boolean;
  /** Запуск (или подготовка выборки) уже идёт — блокирует повторный запуск */
  isPending: boolean;
  /** Идёт сбор состава «выбрать всё» — вместо числа показывается индикатор ожидания */
  isPreparingSelection: boolean;
  /** Запуск выбранной обработки, у генерации заключений — с выбранной областью */
  onRun: (pipeline: ConversationPipeline, scope?: ExpertReportPipelineScope) => void;
};

/**
 * Блок массовых действий, раскрываемый кнопкой «Действия» под строкой поиска (по аналогии с
 * панелью поиска по содержимому диалога): селектор обработки и счётчик отмеченных диалогов.
 * Сам выбор ведётся чекбоксами в строках и мастер-чекбоксом в шапке таблицы.
 */
export const MassActionsBar: FC<Props> = ({ selectedCount, hasSelection, isPending, isPreparingSelection, onRun }) => {
  const { t } = useTranslation(['dialogs']);

  return (
    <div className="flex flex-row items-center gap-3">
      <PipelineActions hasSelection={hasSelection} isPending={isPending} onRun={onRun} />
      {isPreparingSelection ? (
        // «Выбрать всё» ещё собирает состав выборки — вместо промежуточного числа показываем ожидание.
        <span className="flex items-center gap-2 text-sm whitespace-nowrap text-muted-foreground">
          {t('dialogs:dialogListSection.massActions.selectedPreparing')}
          <Spinner className="size-4" />
        </span>
      ) : (
        <span className="text-sm whitespace-nowrap text-muted-foreground">
          {t('dialogs:dialogListSection.massActions.selectedCount', { count: selectedCount })}
        </span>
      )}
    </div>
  );
};
